<dx-toolbar class="toolbar">
  <dxi-item location="before" widget="dxTextBox">
    <dx-button stylingMode="outlined" icon="detailslayout" [disabled]="true"> </dx-button>
  </dxi-item>
  <dxi-item
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style=" padding-inline: 10px"
  >{{formTypes[formType]}}
  </dxi-item>
  <dxi-item
    *ngIf="reportCode"
    location="before"
    widget="dxTextBox"
    locateInMenu="auto"
    style="border-inline: 1px solid; padding-inline: 10px"
  >{{reportCode}}
  </dxi-item>
  <dxi-item
    *ngIf="listAction"
    location="before"
    widget="dxTextBox"
    locateInMenu="never"
    style="border-right: 1px solid; padding-inline: 10px"
  >{{listAction}}
  </dxi-item>
  <dxi-item location="center" widget="dxButton" locateInMenu="never">
    <div *dxTemplate>
      <div class="toolbar-label"><b>Dabnet</b></div>
    </div>
  </dxi-item>

  <dxi-item
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="toastMessageButtonOptions"
  >
  </dxi-item>


  <dxi-item
    id="btnHelp"
    location="after"
    widget="dxButton"
    locateInMenu="never"
    [options]="helpButtonOptions"
  >
  </dxi-item>



</dx-toolbar>


<dx-popover
  target="dx-toolbar #btnHelp"
  showEvent="click"
  position="top"
  hideEvent="mouseleave"
  [hideOnOutsideClick]="false"
  [width]="300"
>
  <div *dxTemplate="let data = model; of: 'content'">
    <p>Dabnet Bilişim Tekn.Ltd.Şti</p>
    <a href="http://www.dabnet.com.tr"><p>www.dabnet.com.tr</p></a>
  </div>
</dx-popover>
